<template>
  <div id="page">
    <b-container>
      <div v-for="(item, index) in themes" :key="index">
        <b-card
          no-body
          class="overflow-hidden mt-2"
          @click="toSelectCardface(item)"
        >
          <b-row no-gutters>
            <b-col md="6" class="mx-auto">
              <b-card-img
                :src="item.subjectUrl"
                alt="Image"
                class="rounded-0"
              ></b-card-img>
            </b-col>
            <b-col md="12">
              <b-card-body :title="item.subjectName" class="text-center">
                <b-card-text>
                  {{ item.subjectDesc }}
                </b-card-text>
              </b-card-body>
            </b-col>
          </b-row>
        </b-card>
      </div>
    </b-container>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "CardTheme",
  data() {
    return {
      area: "",
      bankSerialNumber: "",
      bankCode: "",
      themes: [
        {
          id: 1,
          subjectUrl: "/static/custom_pat.png",
          subjectName: "宠物主题卡",
          subjectDesc: "他们不懂幸福，却能读懂你笑的音符",
        },
      ],
      backgroudColorList: [
        {
          id: "",
          hexCode: "",
          rgbCode: "",
          nameCN: "",
          nameEN: "",
          isUsed: "",
        },
      ],
      cardTechnologyList: [
        {
          id: "",
          technologyName: "",
          technologyUrl: "",
        },
      ],
    };
  },
  methods: {
    toSelectCardface: function (item) {
      let theme = {
        themeType: item.id,
        backgroudColorList: this.backgroudColorList,
        cardTechnologyList: this.cardTechnologyList,
      };

      let selectedTheme = JSON.stringify(theme);
      console.log(selectedTheme);

      this.$router.push({
        name: "SelectCardface",
        query: {
          bankSerialNumber: this.bankSerialNumber,
          bankCode: this.bankCode,
        },
        params: {
          cardTheme: selectedTheme,
        },
      });
    },
    queryCardTheme: function () {
      let that = this;
      axios
        .get("https://cp.hengbao.net.cn/pos/order/queryBankDict", {
          params: {
            bankCode: this.bankCode,
          },
        })
        .then(function (response) {
          console.log(response);
          let data = response.data;
          that.themes = data.cardSubjectList;
          that.backgroudColorList = data.backgroudColorList;
          that.cardTechnologyList = data.cardTechnologyList;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
  mounted: function () {
    this.$data.area = this.$route.query.area;
    this.bankSerialNumber = this.$route.query.bankSerialNumber;
    this.bankCode = this.$route.query.bankCode;
    console.log("bankSerialNumber:" + this.bankSerialNumber);
    console.log("bankCode:" + this.bankCode);
    this.queryCardTheme();
  },
};
</script>

<style scoped>
.lefttext {
  text-align: left;
}

.img {
  width: 60%;
  height: 40%;
}
</style>



// WEBPACK FOOTER //
// src/components/CardTheme.vue